import { AxiosPromise } from "axios";
import { CONSTANT_CONFIG } from "@/constants";
import { HttpService } from "@/services/http.services";

const RESOURCE_ENDPOINT = `${CONSTANT_CONFIG.GRANT_SERVER_PREFIX}/special-research-grant-application`;
const endpoints = {
    list: () => `${RESOURCE_ENDPOINT}`,
    getById: (id: any) => `${RESOURCE_ENDPOINT}/${id}`,
    getByMyRecordId: (id: any) => `${RESOURCE_ENDPOINT}/my-record/${id}`,
    getByWhere: () => `${RESOURCE_ENDPOINT}/getByWhere`,
    getByApplicationId: (applicationId: any) => `${RESOURCE_ENDPOINT}/application/${applicationId}`,
    create: () => `${RESOURCE_ENDPOINT}`,
    update: (id: Number) => `${RESOURCE_ENDPOINT}/${id}`,
    updatePartial: (id: Number) => `${RESOURCE_ENDPOINT}/${id}`,
    delete: (id: Number) => `${RESOURCE_ENDPOINT}/${id}`,
    bulk: () => `${RESOURCE_ENDPOINT}/bulk`,
    dropdown: () => `${RESOURCE_ENDPOINT}/dropdown`,
    export: () => `${RESOURCE_ENDPOINT}/export`,
    getBudgetSummary: () => `${RESOURCE_ENDPOINT}/getBudgetSummary`,
    updateMeritSerial: () => `${RESOURCE_ENDPOINT}/updateMeritSerial`,
    generateSerial: () => `${RESOURCE_ENDPOINT}/generate-serial`,
    approveFundedResearcher: () => `${RESOURCE_ENDPOINT}/approve-funded-researcher`,
    syncPublications: () => `${RESOURCE_ENDPOINT}/sync-publications`,
    updateAllocation: () => `${RESOURCE_ENDPOINT}/update-allocation`,
    getSummaryDashboard: () => `${RESOURCE_ENDPOINT}/summary-dashboard`,
    updateApplicationResearcherProfileInfo: () => `${RESOURCE_ENDPOINT}/update-application-researcher-profile-info`,
    changePI: () => `${RESOURCE_ENDPOINT}/change-pi`,
    changeAI: () => `${RESOURCE_ENDPOINT}/change-ai`,
    changeMobile: () => `${RESOURCE_ENDPOINT}/change-mobile`,
    changeAIMobile: () => `${RESOURCE_ENDPOINT}/change-ai-mobile`,
    updateByAdmin: (id: Number) => `${RESOURCE_ENDPOINT}/update-by-admin/${id}`,
};

export default class SpecialResearchGrantApplicationApi {
    public list = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.list();

        return HttpService.get(url, params, headers);
    };

    public getById = (id: any): AxiosPromise<any> => {
        const url = endpoints.getById(id);
        return HttpService.get(url);
    };

    public getByMyRecordId = (id: any): AxiosPromise<any> => {
        const url = endpoints.getByMyRecordId(id);
        return HttpService.get(url);
    };

    public getByWhere = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getByWhere();
        return HttpService.get(url, params, headers);
    }

    public getBudgetSummary = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getBudgetSummary();
        return HttpService.get(url, params, headers);
    }

    public getByApplicationId = (applicationId: any): AxiosPromise<any> => {
        const url = endpoints.getByApplicationId(applicationId);
        return HttpService.get(url);
    };

    public create = (
        payload = {},
        params = {},
        headers = {}
    ): AxiosPromise<any> => {
        const url = endpoints.create();
        console.log(payload);
        return HttpService.post(url, payload, params, headers);
    };

    public update = (
        id: any,
        payload = {},
        params = {},
        headers = {}
    ): AxiosPromise<any> => {
        const url = endpoints.update(id);
        return HttpService.put(url, payload, params, headers);
    };

    public updatePartial = (
        id: any,
        payload = {},
        params = {},
        headers = {}
    ): AxiosPromise<any> => {
        const url = endpoints.updatePartial(id);
        return HttpService.patch(url, payload, params, headers);
    };

    public delete = (id: any, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.delete(id);
        return HttpService.delete(url, params, headers);
    };

    public bulk = (
        payload = {},
        params = {},
        headers = {}
    ): AxiosPromise<any> => {
        const url = endpoints.bulk();
        return HttpService.post(url, payload, params, headers);
    };
    public dropdown = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.dropdown();
        return HttpService.get(url, params, headers);
    };
    public updateMeritSerial = (payload = {}, params = {}): AxiosPromise<any> => {
        const url = endpoints.updateMeritSerial();
        return HttpService.post(url, payload, params);
    };
    public generateSerial = (payload = {}, params = {}): AxiosPromise<any> => {
        const url = endpoints.generateSerial();
        return HttpService.post(url, payload, params);
    };
    public approveFundedResearcher = (payload = {}, params = {}): AxiosPromise<any> => {
        const url = endpoints.approveFundedResearcher();
        return HttpService.post(url, payload, params);
    };
    public syncPublications = (payload = {}, params = {}): AxiosPromise<any> => {
        const url = endpoints.syncPublications();
        return HttpService.post(url, payload, params);
    };
    public updateAllocation = (payload = {}, params = {}): AxiosPromise<any> => {
        const url = endpoints.updateAllocation();
        return HttpService.post(url, payload, params);
    };
    public getSummaryDashboard = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getSummaryDashboard();
        return HttpService.post(url, payload, params, headers);
    };
    public updateApplicationResearcherProfileInfo = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.updateApplicationResearcherProfileInfo();
        return HttpService.post(url, payload, params, headers);
    };
    public changePI = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.changePI();
        return HttpService.post(url, payload, params, headers);
    };

    public changeAI = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.changeAI();
        return HttpService.post(url, payload, params, headers);
    };
    public changeMobile = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.changeMobile();
        return HttpService.post(url, payload, params, headers);
    };
    public changeAIMobile = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.changeAIMobile();
        return HttpService.post(url, payload, params, headers);
    };
    public updateByAdmin = (
        id: any,
        payload = {},
        params = {},
        headers = {}
    ): AxiosPromise<any> => {
        const url = endpoints.updateByAdmin(id);
        return HttpService.put(url, payload, params, headers);
    };
    public export = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.export();
        return HttpService.post(url, payload, params, headers);
    };
}
